// extracted by mini-css-extract-plugin
export var ddIcon = "_header-module--ddIcon--4a967";
export var mainMenu = "_header-module--mainMenu--f83c7";
export var menuDropDown = "_header-module--menuDropDown--86a2d";
export var menuDropDownFull = "_header-module--menuDropDownFull--ac4e0";
export var menuDropDownHug = "_header-module--menuDropDownHug--d9f42";
export var menuItem = "_header-module--menuItem--4c9c0";
export var menuItemLink = "_header-module--menuItemLink--d3860";
export var menuItemLinkActive = "_header-module--menuItemLinkActive--a34dd";
export var menuLabel = "_header-module--menuLabel--72de9";
export var menuWrapper = "_header-module--menuWrapper--6ab38";
export var mobileMenu = "_header-module--mobileMenu--8ad51";
export var navbar = "_header-module--navbar--ec8ac";
export var navbarContainer = "_header-module--navbarContainer--06a61";
export var showMenu = "_header-module--showMenu--46547";
export var utilities = "_header-module--utilities--8e425";